/**
 * Facet accessors shared by the catalog table and the catalog graph, so both
 * read a given dimension off an entity the same way. Each returns '' when the
 * entity carries no value for that facet.
 */

export function getEntityOwner(entity: any): string {
  const owner = entity.spec?.owner;
  if (owner) return owner.replace(/^(group|user):default\//, '');
  const rel = entity.relations?.find((r: any) => r.type === 'ownedBy');
  return rel?.targetRef?.replace(/^(group|user):default\//, '') ?? '';
}

export function getEntityRegion(entity: any): string {
  return entity.metadata?.annotations?.['verint.com/region'] ?? '';
}

export function getEntityEnv(entity: any): string {
  return entity.spec?.lifecycle || entity.metadata?.labels?.['verint.com/env'] || '';
}

export function getEntityTeam(entity: any): string {
  return entity.metadata?.annotations?.['verint.com/team'] ?? '';
}

export function getEntityDomain(entity: any): string {
  return entity.metadata?.annotations?.['verint.com/domain'] || entity.spec?.domain || '';
}

export function getEntityOwningVp(entity: any): string {
  return entity.metadata?.annotations?.['verint.com/owning-vp'] ?? '';
}

export function getEntityCsp(entity: any): string {
  return entity.metadata?.annotations?.['verint.com/csp'] ?? '';
}

/** Customers are multi-valued, unlike the other (single-valued) facets. */
export function getEntityCustomers(entity: any): string[] {
  const raw = entity.metadata?.annotations?.['verint.com/customers'];
  if (!raw) return [];
  return String(raw).split(',').map((c: string) => c.trim()).filter(Boolean);
}

/** A pending entity is not yet available as a dependency target in the registry. */
export function getEntityPending(entity: any): boolean {
  return entity.metadata?.annotations?.['verint.com/pending'] === 'true';
}

